import { Button } from "@/shared/ui";

type Props = {
  valueDefault?: string | number;
  value: string | number;
  valueTitle?: string | number | ((value: string | number) => string | number);
  variants: (string | number)[];
  onChange: (value: string | number) => void;
  images?: string;
};

export default function CreateCharacterVariantSelectForm({
  valueDefault,
  value,
  valueTitle,
  variants,
  onChange,
  images,
}: Props) {
  return (
    <div className="rounded-b-xl mt-px p-5 bg-dark-800">
      <div className="grid grid-cols-5 gap-1.5 [scrollbar-gutter:stable] [--scrollbar-track-bg:linear-gradient(#402862,#B54876)] -mr-5 pr-5 overflow-y-auto place-content-start max-h-[9.75rem] rounded-lg">
        {variants.map((variant, index) => {
          let title = "";
          if (typeof valueTitle === "function") {
            title = String(valueTitle(variant));
          } else {
            title = valueTitle ? String(variant[valueTitle]) : String(variant);
          }

          if (valueDefault !== null && valueDefault !== undefined && valueDefault === variant) {
            title = "Нет";
          }

          return (
            <Button
              key={title}
              variant={variant === value ? "solid-surface-gradient" : "solid"}
              color={variant === value ? "accent" : "matched"}
              noninteractive={variant === value}
              className="aspect-square w-full h-auto"
              onClick={() => {
                onChange(variant);
              }}
            >
              {images ? (
                <img
                  src={`/img/customization/${images}/${index}.png`}
                  alt={String(variant)}
                  className="w-full h-full object-cover rounded-xl"
                />
              ) : (
                title
              )}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
